import React, { useEffect, useRef } from 'react';
import { TI_STATUSES } from '../../triage/config';
import type { TriageStatus } from '../../triage/types';

export interface TriageStatusMenuProps {
  open: boolean;
  currentStatus: TriageStatus;
  onSelect: (status: TriageStatus) => void;
  onClose: () => void;
  anchorStyle?: React.CSSProperties;
}

export function TriageStatusMenu({
  open,
  currentStatus,
  onSelect,
  onClose,
  anchorStyle,
}: TriageStatusMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) onClose();
    };
    if (open) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open, onClose]);

  if (!open) return null;

  const current = TI_STATUSES[currentStatus];
  const allowed = current?.canTransitionTo ?? [];

  return (
    <div ref={menuRef} className="ti-menu" style={{ ...anchorStyle, minWidth: 240 }}>
      <div className="ti-menu-eyebrow">Move to</div>
      {allowed.map((key) => {
        const s = TI_STATUSES[key];
        if (!s) return null;
        return (
          <div
            key={key}
            className="ti-menu-item"
            role="button"
            tabIndex={0}
            onClick={() => onSelect(key)}
          >
            <span className="ti-status-dot" style={{ background: s.dot, width: 8, height: 8 }} />
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--ink-0)' }}>{s.label}</div>
              <div style={{ fontSize: 10.5, color: 'var(--ink-3)', lineHeight: 1.4 }}>{s.description}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
